"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactRedux = require("react-redux");
var _style = _interopRequireDefault(require("./style.css"));
var _flag = _interopRequireDefault(require("cccisd-icons/flag5"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up5"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ProgressBar = /*#__PURE__*/function (_React$Component) {
  _inherits(ProgressBar, _React$Component);
  var _super = _createSuper(ProgressBar);
  function ProgressBar() {
    _classCallCheck(this, ProgressBar);
    return _super.apply(this, arguments);
  }
  _createClass(ProgressBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        progressBar = _this$props.progressBar,
        useFlex = _this$props.useFlex;

      // RETURN - do not display if less than 2 elements
      if (progressBar.length < 2) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
      }
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: (0, _classnames["default"])(_style["default"].barWrapper, 'progress', useFlex ? _style["default"].flex : _style["default"].fixed)
      }, (0, _map2["default"])(progressBar, function (step, i) {
        var statusStyle = '';
        switch (step.status) {
          case 'not_started':
            statusStyle = _style["default"].notStarted;
            break;
          case 'started':
            statusStyle = 'progress-bar-striped ' + _style["default"].started;
            break;
          case 'completed':
            statusStyle = 'progress-bar-info';
            break;
          default:
            break;
        }
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: i,
          className: (0, _classnames["default"])(statusStyle, 'progress-bar')
        }, step.isCurrent && /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].current
        }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null)), step.isMilestone && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_flag["default"], null)));
      }));
    }
  }]);
  return ProgressBar;
}(_react["default"].Component);
_defineProperty(ProgressBar, "propTypes", {
  useFlex: _propTypes["default"].bool,
  // From redux
  progressBar: _propTypes["default"].array
});
_defineProperty(ProgressBar, "defaultProps", {
  useFlex: false
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    progressBar: state.assignment.player.progressBar
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(ProgressBar);
exports["default"] = _default;